<template>
  <add-approver-dialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    :popupTop="'10vh'"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'1000px'"
    :append-to-body="true"
  >
    <div class="container">
      <el-form
        :inline="true"
        :model="query"
        ref="query"
        style="display: flex; justify-content: space-between"
      >
        <el-form-item label="姓名" prop="workflowDefinitionName">
          <el-input v-model="query.realName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >查询</el-button
          >
          <el-button type="primary" icon="el-icon-delete" @click="handleClear"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 批量选择 -->
    <div class="approve_title">
      <div style="display: flex; align-items: center">审批人</div>
    </div>
    <TableList
      :row-key="rowKey"
      :table-data="tableData"
      :table-label="tableLabel"
      :selection-show="true"
      ref="multipleTable"
      @handleSelectionChange="handleSelectionChange"
      @handleSelect="handleSelect"
    >
      <template v-slot:index="slot">
        {{ slot.scope.$index + 1 }}
      </template>
      <template v-slot:operation="slot">
        <el-button
          @click="handleApproverTrue(slot.scope.$index)"
          :disabled="slot.scope.row.approverFlag"
          >{{
            slot.scope.row.isApprover ? "删除审批人" : "设为审批人"
          }}</el-button
        >
      </template>
    </TableList>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="productTagPage.pageNum"
        @size-change="handleSizeChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="productTagPage.pageSize"
        :total="productTagPage.pageTotal"
        @current-change="handlePageChange"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
  </add-approver-dialog>
</template>

<script>
import AddApproverDialog from "../../../../components/common/epecDialog";
import TableList from "../../components/common/e-table-list";
import Api from "../../api/company/index";
export default {
  name: "addApproverDialog1",
  components: {
    AddApproverDialog,
    TableList,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    approverTableData: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      query: {
        realName: "",
        organization: "",
      },
      newApprovalList: [],
      approverFlag: false,
      checkAll: false,
      tableData: [],

      tableLabel: [
        { label: "姓名", param: "realName", align: "center" },
        { label: "登录名", param: "memberName", align: "center" },
        { label: "联系方式", param: "mobile", align: "center" },
        { label: "操作", align: "center", slot: "operation" },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      rowKey: "memberName",
    };
  },
  computed: {},
  created () {
    this.getMemberList();
  },
  methods: {
    updateVisible () { },
    resetPopupData () {
      this.$emit("close");
    },
    submitPopupData () {
      let params = {
        workflowDefinitionName: this.$getStore("workflowDefinitionName"),
        level: this.$getStore("index"),
        approverList: [...this.newApprovalList, ...this.approverTableData],
      };
      if (params.approverList.length == 0) {
        this.$message.warning("请添加审批人!");
      } else {
        this.getData(params);
        this.$emit("close");
      }
      
    },
    handleSearch () {
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageNum = 1;
      this.getMemberList();
    },
    handleClear () {
      this.query = {};
    },

    getMemberList () {
      let params = {
        realName: this.query.realName,
        organization: this.query.organization,
        pageSize: this.productTagPage.pageSize,
        pageNum: this.productTagPage.pageNum,
      };
      let workFlowSkusList =
        this.$getStore("workFlowSkusList") == null
          ? null
          : JSON.parse(this.$getStore("workFlowSkusList"));
      Api.queryMembers(params).then((res) => {
        if (res.code == "200") {
          let temp = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
          temp.forEach((each) => {
            this.$set(each, "isApprover", false);
            this.$set(each, "approverFlag", false);
          });
          if (null != workFlowSkusList) {
            this.newApprovalList.forEach((each) => {
              temp.forEach((e) => {
                if (e.memberName == each.memberName) {
                  e.isApprover = true;
                  // e.approverFlag = true;
                }
              });
            });
          }
          this.tableData = temp;
          this.handleApproverFlag();
        }
      });
    },

    // 添加过的审批人不可再添加
    handleApproverFlag () {
      this.tableData.map((item, index) => {
        this.approverTableData.map((item2) => {
          if (item.memberName == item2.memberName) {
            this.tableData[index].approverFlag = true;
          }
        });
      });
    },

    // table批量选择
    handleSelectionChange (list) {
      this.newApprovalList = list;
      if (list.length) {
        list.forEach((row) => {
          if (!row.approverFlag) {
            this.tableData.map((item) => {
              if (
                item.memberName == row.memberName &&
                item.password == row.password
              ) {
                item.isApprover = true;
              }
            });
            this.$refs.multipleTable.$refs.table.toggleRowSelection(row, true);
          } else {
            this.$refs.multipleTable.$refs.table.toggleRowSelection(row, false);
          }
        });
      } else {
        this.tableData.forEach((row) => {
          row.approverFlag ? row.isApprover = true : row.isApprover = false;
        });
      }
    },

    handleSelect (rows) {
      console.log(rows)
      if (rows.row.approverFlag) {
        return;
      } else {
        rows.rows.length === this.tableData.length ? (this.checkAll = true) : (this.checkAll = false);
        this.checkAll ? rows.row.isApprover = true : rows.row.isApprover = false;
      }
    },

    handleApproverTrue (val) {
      this.tableData[val].isApprover = !this.tableData[val].isApprover;
      if (this.tableData[val].isApprover) {
        this.$refs.multipleTable.$refs.table.toggleRowSelection(
          this.tableData[val],
          true
        )
      } else {
        this.$refs.multipleTable.$refs.table.toggleRowSelection(
          this.tableData[val],
          false
        )
      }
    },
    getData (params) {
      this.$emit("getData", params);
      this.$setStore("workFlowSkusList", params);
      this.$emit("close");
    },

    //分页导航
    handlePageChange (val) {
      this.productTagPage.pageNum = val;
      this.getMemberList();
    },
    handleSizeChange (val) {
      this.productTagPage.pageNum = 1
      this.productTagPage.pageSize = val;
      this.getMemberList();
    },
  },
};
</script>

<style scoped lang='scss'>
.approve_title {
  background: #f5f7fa;
  width: 100%;
  height: 50px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.pagination{
  text-align: right;
}
</style>
